// extracted by mini-css-extract-plugin
module.exports = {"label":"_2REGYI7","label_root_compact":"_37yyTNX"};